import { ErrorMessages, ProductType } from '@inter-ikea-storageone/range';
import { reportChangePushOpenFunction } from 'analytics/reporters';
import { ComponentIds, HierarchyUtils } from '@inter-ikea-core/core';
import { BehaviorParameters } from 'rangeConfig/@types';
import { changeDrawerOpeningFunction } from 'rangeConfig/shared/utils/frontLayouts';
import { hideNoFramesInSceneErrorMessage } from 'rangeConfig/shared/rules/hideMenuRules';

const addHandleToFront = ({ coreApi, props, rootState }: BehaviorParameters) => {
  let selectedEntity =
    coreApi.entities.findSelectedEntity() ||
    coreApi.entities.getEntityClosestToPosition(props.position, [
      ComponentIds.DOOR_COMPONENT_ID,
      ComponentIds.DRAWER_COMPONENT_ID
    ]);
  const getIsDrawer = selectedEntity?.hasComponent(ComponentIds.DRAWER_COMPONENT_ID);

  if (!hideNoFramesInSceneErrorMessage(coreApi)) {
    coreApi.emit.onPlacementAttempt(ErrorMessages.NoFramesInScene);
  }

  if (selectedEntity?.hasComponent(ComponentIds.DRAWER_COMPONENT_ID)) {
    changeDrawerOpeningFunction(
      selectedEntity,
      ProductType.BESTA_SOFT_CLOSING,
      rootState.products.inMarket,
      coreApi,
      false
    );
    selectedEntity =
      coreApi.entities.findSelectedEntity() ||
      coreApi.entities.getEntityClosestToPosition(props.position, [
        ComponentIds.DOOR_COMPONENT_ID,
        ComponentIds.DRAWER_COMPONENT_ID
      ]);
  }
  if (selectedEntity) {
    const existingHandle = HierarchyUtils.getDescendantWithComponent(
      selectedEntity,
      ComponentIds.HANDLE_COMPONENT_ID
    );
    if (existingHandle) {
      coreApi.entities.delete(existingHandle);
    } else {
      reportChangePushOpenFunction({
        pushOpenSelected: false,
        allFronts: false,
        articles: [props.globalItemNo],
        frontType: getIsDrawer ? 'drawer' : 'door',
        menu: 'selected_menu'
      });
    }
    coreApi.products.addToTarget(props.coreProductId, selectedEntity);
  }
};

export default addHandleToFront;
